import { render, staticRenderFns } from "./OneOnOneRoom.vue?vue&type=template&id=aa359bca&"
import script from "./OneOnOneRoom.vue?vue&type=script&lang=ts&"
export * from "./OneOnOneRoom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports